export enum HttpStrategies {
  GET = 1,
  POST = 2,
}
